import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import CustomStepper from "../../components/CustomStepper";
import { BackSvg, ClearSvg } from "../../resources/assetsManager";
import BasicDetails from "./BasicDetails";
import ClientBankDetails from "./ClientBankDetails";
import ClientFileUploads from "./ClientFileUploads";
import ConfirmationModal from "./ConfirmationModal";

function RegisterIndex({ onClose }) {
  const [step, setStep] = useState(0);
  const [email, setEmail] = useState("");
  const [currentStep, setCurrentStep] = useState(1);
  const [clientData, setClientData] = useState({});
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100vh",
      }}
    >
      <div
        style={{
          width: "100%",
          marginTop: 10,
          padding: "10px 15px",
          minWidth: 350,
          maxWidth: 450,
          height: "auto",
          maxHeight: 600,
          backgroundColor: "#F9F9FB",
          boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          position: "relative",
          borderRadius: "10px",
        }}
      >
        {currentStep !== 1 && currentStep !== 4 && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              borderRadius: 5,
              cursor: "pointer",
              position: "absolute",
              left: 20,
              top: 25,
            }}
            onClick={() => {
              setCurrentStep(currentStep - 1);
            }}
          >
            <BackSvg
              style={{
                width: 30,
                height: 30,
              }}
            />
          </div>
        )}
        {currentStep !== 4 && (
          <>
            {" "}
            <p>
              {currentStep === 1
                ? "Basic Details"
                : currentStep === 2
                ? "Business Details"
                : currentStep === 3
                ? "Upload Documents"
                : null}
            </p>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                borderRadius: 5,
                cursor: "pointer",
                position: "absolute",
                right: 20,
                top: 25,
              }}
              onClick={() => {
                navigate("/login");
              }}
            >
              <ClearSvg
                style={{
                  width: 30,
                  height: 30,
                }}
              />
            </div>
          </>
        )}

        {currentStep === 1 ? (
          <BasicDetails
            onClickBack={() => {
              navigate("/login");
            }}
            onClickNext={(data) => {
              setCurrentStep(2);
              setClientData({ ...clientData, ...data });
            }}
          />
        ) : currentStep === 2 ? (
          <ClientBankDetails
            onClickBack={() => {
              setStep(1);
            }}
            onClickNext={(data) => {
              setCurrentStep(3);
              setClientData({ ...clientData, ...data });
            }}
            onSuccess={() => setCurrentStep(2)}
            clientData={clientData}
          />
        ) : currentStep === 3 ? (
          <ClientFileUploads
            onClickBack={() => {
              setStep(1);
            }}
            onClickNext={(data) => {
              // setClientData({ ...clientData, data });
            }}
            onSuccess={() => setCurrentStep(4)}
            clientData={clientData}
          />
        ) : currentStep === 4 ? (
          // <ClientFileUploads
          //   onClickBack={onClose}
          //   onClickNext={(data) => {
          //     setClientData({ ...clientData, data });
          //   }}
          // />
          <ConfirmationModal />
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}

export default RegisterIndex;

// : currentStep === 2 ? (
//   <ClientBankDetails
//     onClickBack={onClose}
//     onClickNext={(data) => {
//       setCurrentStep(3);
//       dispatch(modalNavigation(3));
//       dispatch(addClientData({ ...data }));
//     }}
//     reduxData={clientData}
//   />
// ) : currentStep === 3 ? (
//   <ClientFileUploads
//     onClickBack={onClose}
//     onClickNext={(data) => {
//       setCurrentStep(4);
//       dispatch(modalNavigation(4));
//       dispatch(addClientData({ ...data }));
//     }}
//     reduxData={clientData}
//   />
// ) : currentStep === 4 ? (
//   <ResellerDetails1
//     reduxData={clientData}
//     onClickNext={(data) => {
//       setCurrentStep(5);
//       dispatch(modalNavigation(5));
//       dispatch(addClientData({ ...data }));
//     }}
//     onClickBack={onClose}
//   />
// ) : currentStep === 5 ? (
//   <RollingReserve
//     reduxData={clientData}
//     onSuccess={onSuccess}
//     onClickBack={onClose}
//   />
// )
